import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, watch, inject, onMounted, onBeforeUnmount } from 'vue';
import Checkbox from '../elements/Checkbox.vue';
import { FormCheckBoxEmits, FormCheckboxProps, FormCheckboxRef } from '@/types/form/form-checkbox';
import { DynamicFormContext } from '@/types/form/dynamic-form';
import FormElMsg from '@/form/other/FormElMsg.vue';
import { FormElMsgData } from '@/types/form/others/form-el-msg';
import SiteRichText from '@/elements/SiteRichText.vue';

const FIELD_TYPE = 'form-checkbox';

export default /*@__PURE__*/_defineComponent({
  __name: 'FormCheckbox',
  props: {
    item: {},
    onChange: { type: Function }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;
const formContext = inject<DynamicFormContext>('formContext')!;
const rootEl = ref(null);
const getCheckedValue = (value: unknown) =>
  value === true || value === 'true' || value === 1 || value === '1';
const checked = ref(getCheckedValue(props.item?.fields?.checked?.value));
const isRequired = ref(props.item?.fields?.required?.value ?? false);
const isDisabled = ref(false);
const isVisible = ref(true);
const msg = ref<FormElMsgData>();
const fields = computed(() => props.item?.fields);
const fieldName = computed(() => fields.value?.fieldName?.value || '');

// Reset error when checked state changes
const onCheckboxChange = () => {
  msg.value = undefined;
  emit('change', FIELD_TYPE, fieldName.value, checked.value, checked.value);
};

const onTextClick = (e: any) => {
  if (isDisabled.value) return;
  if (e.target && e.target.tagName !== 'A') {
    checked.value = !checked.value;
    onCheckboxChange();
  }
};

const setRequired = (required: boolean) => {
  isRequired.value = required;
};

const setDisabled = (disabled: boolean) => {
  isDisabled.value = disabled;
};

const setVisible = (visible: boolean) => {
  isVisible.value = visible;
};

const updateValue = (newValue?: string | null) => {
  checked.value = getCheckedValue(newValue);
  onCheckboxChange();
};

const validate = async () => {
  const result = {
    value: checked.value,
    valid: true,
    message: '',
  };

  if (!isVisible.value) {
    return result;
  }

  if (isRequired.value && !checked.value) {
    result.valid = false;
    result.message = fields.value?.requiredMsg?.value || 'This field is required';
    msg.value = {
      type: 'error',
      message: result.message,
    };
    return result;
  }
  msg.value = undefined;
  return result;
};

const getRefData = (): FormCheckboxRef => ({
  el: rootEl.value,
  type: 'form-checkbox',
  name: fieldName.value,
  id: props.item.id,
  visible: isVisible.value,
  setRequired,
  setDisabled,
  setVisible,
  updateValue,
  validate,
  getValue: () => checked.value,
});

// Register this component with parent
watch(
  () => props.item,
  () => {
    checked.value = getCheckedValue(props.item?.fields?.checked?.value);
    isRequired.value = props.item?.fields?.required?.value ?? false;
    formContext.regFormEl(getRefData());
  },
  { immediate: true }
);
onMounted(() => {
  formContext.regFormEl(getRefData());
});
onBeforeUnmount(() => {
  formContext.unRegFormEl(getRefData());
});
__expose(getRefData());

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['f-checkbox', { disabled: isDisabled.value, 'has-error': msg.value?.type === 'error' }]),
        ref_key: "rootEl",
        ref: rootEl
      }, [
        _createVNode(Checkbox, {
          value: checked.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
          disabled: isDisabled.value,
          onChange: onCheckboxChange
        }, null, 8, ["value", "disabled"]),
        _createElementVNode("div", {
          class: "f-checkbox__text",
          onClick: onTextClick
        }, [
          (fields.value?.mandatoryText)
            ? (_openBlock(), _createBlock(SiteRichText, {
                key: 0,
                field: fields.value.mandatoryText
              }, null, 8, ["field"]))
            : _createCommentVNode("", true),
          _createVNode(FormElMsg, { msg: msg.value }, null, 8, ["msg"])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})